import { useTranslation } from 'react-i18next';
import { InternalIncidentInfo } from 'features/geoEvents/components/InternalIncidentInfo';
import { Flooding } from 'features/flooding/flooding.types';
import { Location } from 'features/locations/location.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { canReadReporterNotes, usePermissions } from 'hooks/usePermissions';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { TabData } from 'hooks/useTabs';

export const useInternalIncidentTab = (
  geoEvent: Wildfire | Flooding | Location | undefined,
): TabData => {
  const { t } = useTranslation();
  const isInternalTabEnabled = useReleaseFlag('internal_tab_on_incidents');
  const { data: permissionsData, isLoading } = usePermissions({
    geoEventId: geoEvent?.id,
    geoEventType: geoEvent?.geoEventType,
  });

  return {
    tabId: 'internal',
    label: t('geoEvent.tabs.internal'),
    enabled: isInternalTabEnabled && canReadReporterNotes(permissionsData),
    isPending: !geoEvent || isLoading,
    content: <InternalIncidentInfo geoEvent={geoEvent} />,
  };
};
